export default __webpack_public_path__ + "static/media/startup-pop-label.53d450c4.svg";